import { Controller } from "stimulus";

// Mesa conversation composer: channel picker and internal-note toggle. Internal notes are staff-only,
// so the channel bar is replaced by a hint and the box turns amber. Outside the WhatsApp 24-hour
// window (templateRequired) free text and Send stay off: the "Selecionar template" button opens the
// template modal, which sends by itself.
export default class extends Controller {
  static targets = ["box", "channel", "noteField", "chanpick", "replyHint", "noteHint", "noteToggle", "send", "windowHint", "pickButton", "textarea"];
  static values = { templateRequired: Boolean };

  connect() {
    this.refreshSend();
  }

  pickChannel(event) {
    const channel = event.currentTarget.dataset.channel;
    this.channelTarget.value = channel;
    this.chanpickTargets.forEach((btn) => btn.classList.toggle("is-on", btn.dataset.channel === channel));
    this.syncWhatsappControls();
  }

  toggleNote() {
    const isNote = this.noteFieldTarget.value !== "true";
    this.noteFieldTarget.value = isNote ? "true" : "false";

    this.element.classList.toggle("is-note", isNote);
    this.noteToggleTarget.classList.toggle("is-on", isNote);
    this.replyHintTarget.hidden = isNote;
    this.chanpickTargets.forEach((btn) => (btn.hidden = isNote));
    this.noteHintTarget.hidden = !isNote;

    this.sendTarget.textContent = isNote ? "Salvar nota" : "Enviar";
    this.sendTarget.classList.toggle("note", isNote);
    this.syncWhatsappControls();
  }

  refreshSend() {
    this.sendTarget.disabled = !this.isNote() && this.onWhatsapp() && this.templateRequiredValue;
  }

  syncWhatsappControls() {
    const show = this.onWhatsapp() && !this.isNote();
    if (this.hasPickButtonTarget) this.pickButtonTarget.hidden = !show;
    if (this.hasWindowHintTarget) this.windowHintTarget.hidden = !show;
    if (this.hasTextareaTarget) this.textareaTarget.disabled = show && this.templateRequiredValue;
    this.refreshSend();
  }

  onWhatsapp() {
    return this.channelTarget.value === "whatsapp";
  }

  isNote() {
    return this.noteFieldTarget.value === "true";
  }
}
